import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const hazardsRoutes: Routes = [
  {
    title: 'pagesTitles.hazards',
    path: APP_ROUTES.HAZARDS,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardCatalogRead)],
    loadComponent: () => import('./pages/hazards-list').then((m) => m.HazardsList),
  },
];
